import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

export const Manifesto = () => {
  const { t } = useLang();
  return (
    <section id="manifesto" className="py-24 md:py-32" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="text-xs md:text-sm uppercase tracking-[0.25em] text-[#FF7900] mb-6"
        >
          {t.manifesto.overline}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight max-w-3xl"
        >
          {t.manifesto.title}
        </motion.h2>

        <div className="mt-16 md:mt-24 flex flex-col">
          {t.manifesto.chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group grid md:grid-cols-[120px_1fr_2fr] gap-6 md:gap-12 items-start py-10 md:py-14 border-t border-white/10 last:border-b"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <span className="font-display text-5xl md:text-7xl font-medium text-outline group-hover:text-[#FF7900] group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
                {c.n}
              </span>
              <h3 className="font-display text-2xl md:text-3xl font-medium">{c.title}</h3>
              <p className="text-base md:text-lg text-white/60 leading-relaxed">{c.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
